import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icons/icon';

import styles from './dining-data.module.scss';

const DiningData = ({ distance, experience, cuisine }) => {
  return (
    <div className={styles.diningData}>
      {/* Dining Data List */}
      <ul className={styles.diningDataList}>
        <li className={styles.diningDataItem}>
          <span aria-hidden="true">
            <Icon
              icon="locationPin"
              height="20"
              width="20"
              className={styles.locationPin}
            />
          </span>
          <span aria-label={`Distance: ${distance}`}>{distance}</span>
        </li>
        <li className={styles.diningDataItem}>
          <span aria-hidden="true">
            <Icon
              icon="experience"
              height="20"
              width="20"
              className={styles.experience}
            />
          </span>
          <span aria-label={`Experience: ${experience}`}>{experience}</span>
        </li>
        <li className={styles.diningDataItem}>
          <span aria-hidden="true">
            <Icon
              icon="cuisine"
              height="20"
              width="20"
              className={styles.cuisine}
            />
          </span>
          <span aria-label={`Cuisine: ${cuisine}`}>{cuisine}</span>
        </li>
      </ul>
    </div>
  );
};

DiningData.propTypes = {
  distance: PropTypes.string.isRequired,
  experience: PropTypes.string.isRequired,
  cuisine: PropTypes.string.isRequired,
};

export default DiningData;
